import React, { useState, useEffect } from "react";
import { ScheduleTest } from "./Popup/ScheduleTest";
import { Card, CardContent } from '@/components/ui/card';
import { Heading, Text } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Stack } from '@/components/ui/layout';
import { cn } from '@/lib/utils';

function UsersSection() {
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await fetch("/api/select_users_personal_test");
        if (!response.ok) {
          throw new Error("Failed to fetch users");
        }
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
        alert("Failed to fetch users. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const handleUserSelection = (user) => {
    const isSelected = selectedUsers.some((selectedUser) => selectedUser.id === user.id);
    const updatedSelection = isSelected
      ? selectedUsers.filter((selectedUser) => selectedUser.id !== user.id)
      : [...selectedUsers, user];
    setSelectedUsers(updatedSelection);
  };

  const isSelected = (id) => selectedUsers.some((user) => user.id === id);

  const handleScheduleClick = () => {
    if (selectedUsers.length === 0) {
      alert("Please select at least one user.");
      return;
    }
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  if (loading) {
    return (
      <Card className={cn("w-full")}>
        <CardContent className={cn("p-6")}>
          <Text>Loading users...</Text>
        </CardContent>
      </Card>
    );
  }

  return (
    <>
      <Card className={cn("w-full")}>
        <CardContent className={cn("p-6")}>
          <Stack spacing="md">
            <Heading level="h3" className={cn("text-xl font-semibold")}>Users</Heading>
            <div className={cn("space-y-2")}>
              {users.map((user) => (
                <div key={user.id} className={cn("flex items-center space-x-2 p-2 rounded-md hover:bg-muted")}>
                  <Checkbox
                    id={`user-${user.id}`}
                    checked={isSelected(user.id)}
                    onCheckedChange={() => handleUserSelection(user)}
                  />
                  <Label htmlFor={`user-${user.id}`} className={cn("cursor-pointer flex-1")}>
                    {user.email}
                  </Label>
                </div>
              ))}
            </div>
            <Button onClick={handleScheduleClick} className={cn("w-full")}>
              Next: Schedule Test
            </Button>
          </Stack>
        </CardContent>
      </Card>

      <Dialog open={showPopup} onOpenChange={setShowPopup}>
        <DialogContent className={cn("sm:max-w-[600px]")}>
          <ScheduleTest selectedUsers={selectedUsers} onClose={closePopup} />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default UsersSection;
